import React, { PureComponent } from "react";

import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import Uri from "jsuri";

import {
  sortNumeric,
  selectFormat,
  TableContentCell,
  Error,
  getMetricForColumn,
} from "./../../Utils/Utils.js";

class TopPostsThisHour extends PureComponent {
  componentDidMount() {
    this.props.childRef(this);
  }

  renderTable(data) {
    const { cells, title, url } = this.props;

    // add unique ids
    data.forEach((d, i) => (d.id = i));

    const columns = [
      {
        dataField: "title",
        text: "Title",
        style: { width: "230px", minWidth: "230px", textAlign: "left" },
        headerAlign: "left",
        formatter: TableContentCell,
        sort: true,
        formatExtraData: {
          name: new Uri(url).hasQueryParam("p")
            ? new Uri(url).getQueryParamValue("p")
            : url.split("/")[2],
        },
      },
      {
        dataField: "views",
        text: "Views",
        style: { width: "100px", minWidth: "100px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "new_visitors",
        text: "New Visitors",
        style: { width: "100px", minWidth: "100px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
    ];

    const defaultSorted = [
      {
        dataField: "views",
        order: "desc",
      },
    ];

    let selected_columns = columns;
    if (cells && cells.length) {
      selected_columns = [];
      cells.forEach((cell, i) => {
        selected_columns.push(columns.find((o) => o.dataField === cell));
      });
    }

    const filename = title.split(" ").join("_") || "spreadsheet";
    return (
      <ToolkitProvider
        keyField="id"
        data={data}
        columns={selected_columns}
        striped={false}
        hover={false}
        bordered={false}
        exportCSV={{
          fileName: filename + ".csv",
          exportAll: false,
          onlyExportFiltered: true,
        }}
      >
        {(props) => (
          <BootstrapTable
            {...props.baseProps}
            {...props.csvProps}
            defaultSorted={defaultSorted}
            ref={(el) => (this.childRef = el)}
          />
        )}
      </ToolkitProvider>
    );
  }

  builtInExportCSV = () => this.childRef;

  render() {
    const { data } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }

    return this.renderTable(data);
  }
}

export default TopPostsThisHour;
